import client from "../client"

export const getBankAccount = async () => {
  const response = await client.get(`/users/bank/account`)

  return response.data
}
